'use strict';
var parent = require('../../es/promise');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/promise/index.js
// module id = 781
// module chunks = 13